import router from "@/router";
import { EcoNasalThemeVariables } from "@/constants/themes/EcoNasalTheme";
import { ClinicarxThemeVariables } from "@/constants/themes/ClinicarxTheme";
import { EcoSalivaThemeVariables } from "@/constants/themes/EcoSalivaTheme";
import { VyttraProximaThemeVariables } from "@/constants/themes/VyttraProximaTheme";
import { IbmpNasalThemeVariables } from "@/constants/themes/IbmpNasalTheme";
import { ChembioHivThemeVariables } from "@/constants/themes/ChembioHivTheme";

export default class ThemesHelper {
  static getCurrentTheme() {
    if (!router.currentRoute.value.params["theme"]) return null;

    const theme = router.currentRoute.value.params["theme"];

    switch (theme) {
      case "econasal":
        return EcoNasalThemeVariables;
      case "ecosaliva":
        return EcoSalivaThemeVariables;
      case "crx":
        return ClinicarxThemeVariables;
      case "proximanasal":
        return VyttraProximaThemeVariables;
      case "ibmpnasal":
        return IbmpNasalThemeVariables;
      case "surecheckhiv":
        return ChembioHivThemeVariables;
      default:
        return null;
    }
  }

  static async setGlobalTheme() {
    const themeObj = ThemesHelper.getCurrentTheme();
    if (themeObj == null) return false;

    // Setting global variables
    for (const key in themeObj) {
      if (key == 'urlFavicon') continue;

      if (key.includes("urlPath")) {
        const value = themeObj[key as string] as string;
        const path = await import("../assets/themes/" + value);
        const tmpProp = `url(${path.default})`;
        document.documentElement.style.setProperty(`--${key}`, tmpProp);
      } else {
        document.documentElement.style.setProperty(
          `--${key}`,
          themeObj[key as string] as string
        );
      }
    }

    // Setting favicon
    const favicon = document.getElementById("favicon") as any;
    const path = await import("../assets/themes/" + themeObj.urlFavicon);
    favicon.href = path.default;

    // Setting page title
    document.title = themeObj.pageTitle;
  }

  static getThemeParams(key: string): string {
    const themeObj = ThemesHelper.getCurrentTheme();
    return themeObj ? themeObj[key] : "";
  }

  static getUrlImage(key: string): string {
    const value = ThemesHelper.getThemeParams(key);
    return require(`@/assets/themes/${value}`);
  }
}
